import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IonicModule } from '@ionic/angular';

import { MiscModule } from '../../misc/misc.module';
import { CameraPageRoutingModule } from './camera-routing.module';
import { CameraPageComponent } from './camera.page';

@NgModule({
  declarations: [CameraPageComponent],
  imports: [CommonModule, IonicModule, CameraPageRoutingModule, MiscModule]
})
export class CameraPageModule {}
